import React, {
  useEffect, createContext, useCallback, useRef, useState,
  FunctionComponent,
  Dispatch,
  SetStateAction,
} from 'react';
import api from '../api';
import { CcsAccountType } from '../enums';
import { useAppState, useNotification } from '../hooks';
import { ANALYTICS_TIME_INTERVAL } from '../util';

const policyAnalyticsState = createContext<any>({
  isLoading: true,
  analytics: [],
  refresh: (() => {}),
});

const { Provider } = policyAnalyticsState;

const PolicyAnalyticsProvider: FunctionComponent<any> = ({ children }: any) => {
  const { accountId } = useAppState();
  const [analytics, setAnalytics] = useState([]);
  const [loading, setLoading] = useState(false);

  const isMounted = useRef(false);

  const fetchAnalytics = useCallback(async () => {
    if (isMounted.current) {
      setLoading(true);
    }
    try {
      const { data } = await api.mavenAnalytics.getInternalAnalytics(
        accountId, ANALYTICS_TIME_INTERVAL,
      );

      const obj = {} as any;
      data?.policies?.forEach((it:any) => { obj[it.id] = it; });

      if (isMounted.current) {
        setAnalytics(obj);
        setLoading(false);
      }
    } catch (error) {
      setAnalytics([]);
      setLoading(false);
    }
  }, [accountId]);

  useEffect(() => {
    if (accountId) {
      fetchAnalytics();
    }
  }, [accountId, fetchAnalytics]);

  useEffect(() => {
    isMounted.current = true;
    return () => { isMounted.current = false; };
  }, []);

  return (
    <Provider value={{
      analytics,
      loading,
      refresh: fetchAnalytics,
    }}
    >
      {children}
    </Provider>
  );
};

export {
  policyAnalyticsState,
};
export default PolicyAnalyticsProvider;
